import { FormConfig } from '@shared/interfaces/form-configs/form-config';
import {
  CreateMeteringPointCommand,
  ProductCharacteristicIdentification,
  ProductCharacteristicUnitType
} from '@app/api/dmc';

export const meteringpointtypeProductionFormConfig: FormConfig<CreateMeteringPointCommand> = {
  'detailCharacteristics.productCharacteristicIdentification': {
    value: ProductCharacteristicIdentification.EnergyActive,
    state: 'required',
  },
  'detailCharacteristics.productCharacteristicUnitType': {
    value: ProductCharacteristicUnitType.KWH,
    state: 'required',
  },
  'detailCharacteristics.fromGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.toGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.netSettlementGroup': {
    state: 'required',
  },
  'detailCharacteristics.disconnectionType': {
    state: 'required',
  },
  'detailCharacteristics.settlementMethod': {
    state: 'disabled',
  },
  'detailCharacteristics.assetType': {
    state: 'required',
  },
  'detailCharacteristics.connectionType': {
    state: 'required'
  },
  'detailCharacteristics.capacity': {
    state: 'required',
  },
  'detailCharacteristics.powerPlantIdentification': {
    state: 'required'
  },
  'parentMeteringPointIdentification': {
    state: 'disabled',
  },
  'connectionPointId': {
    state: 'required',
  },
  // TS-Ignore necessary to reference a field that doesn't exist.
  // @ts-expect-error TS2353: extra property
  'connectionPointIdentification': {
    state: 'required',
    optional: true,
  },
  'connectionPointAddress': {
    state: 'required',
    optional: true,
  }
}
